import React from 'react';
import clsx from 'clsx';
import { XR } from '../index';
export function LayoutContent(_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.sidebarId, sidebarId = _c === void 0 ? '' : _c, _d = _a.maxWidth, maxWidth = _d === void 0 ? 1600 : _d;
    var sidebar = XR.useLayout().sidebar;
    return (React.createElement("div", { className: clsx(className, 'XR-LayoutContent', { isOpen: sidebar.isOpen(sidebarId) }, (_b = sidebar.getById(sidebarId)) === null || _b === void 0 ? void 0 : _b.visible), style: {
            maxWidth: sidebar.getWidth(sidebarId) + maxWidth,
            paddingLeft: sidebar.getPaddingLeft(sidebarId),
        } }, children));
}
